export default __webpack_public_path__ + "static/media/swiftstrikes1.f43c338d.png";